module.exports = {"title":"SENTINEL","outlets":"Stations","outlet":"Station","franchise":"Station","franchise_icon":"\\u{e546}","setel":"Setel","setel_type":"6","total_setel":"total_setel","centrals":"POS","central":"POS","order_layout":"Speedkey","grid":"Speedkey","order":"","tag":"Sales Category","tags":"Sales Category","categories":"Loyalty Category","category":"Loyalty Category","items":"Non Fuel","outlets_assigned":"stations assigned","applicable_outlets":"Applicable stations","leave_empty_if_applicable_to_all_outlets":"Leave empty if applicable to all stations"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/general.php
// module id = LIgU
// module chunks = 99